module.exports = __webpack_public_path__ + "216817689cbd5a97dd3dc0645032ebf5.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/assets/greenThimble.svg
// module id = 4152
// module chunks = 25